module.exports = __webpack_public_path__ + "media/dynamic-is-better-v2.8ec52f74.mp4";